import { REMITTANCE_STEPS } from '@cashier/pages/remittance/types';
import type { RemittancePlace } from '@shared/types';
import i18next from 'i18next';

const t = (key: string) => i18next.t(key, { ns: 'cashier' });

export enum REMITTANCE_COMPANY {
  OTHERS = 'OTROS',
  WESTERN_UNION = 'WESTERN_UNION',
}

export const REMITTANCE_FIELD_LIMITS = {
  DOCUMENT_NUMBER: 11,
  CODE: 24,
  CELLPHONE: 8,
  CUSTOM_TEXT_MIN: 4,
  CUSTOM_TEXT_MAX: 100,
  COMPANY_NAME: 50,
} as const;

export const PENDING_CHIP_SX = {
  ml: 2,
  px: '12px',
  py: '4px',
  backgroundColor: '#d2eaff',
  borderRadius: '50px',
  color: '#037AE8',
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px',
  fontFamily: 'Roboto',
  width: 'fit-content',
} as const;

export const getRemittanceCompanyOptions = () =>
  [
    { value: REMITTANCE_COMPANY.OTHERS, label: t('remittance.companyOthers') },
    { value: REMITTANCE_COMPANY.WESTERN_UNION, label: t('remittance.companyWesternUnion') },
  ] as const;

export const getRemittancePageCopy = () =>
  ({
    [REMITTANCE_STEPS.searching]: {
      title: t('remittance.pageSearchTitle'),
      description: t('remittance.pageSearchDescription'),
    },
    [REMITTANCE_STEPS.confirm]: {
      title: t('remittance.pageSearchTitle'),
      description: t('remittance.pageSearchDescription'),
    },
    [REMITTANCE_STEPS.codeEntry]: {
      title: t('remittance.pageCodeEntryTitle'),
      description: t('remittance.pageCodeEntryDescription'),
    },
    [REMITTANCE_STEPS.summary]: {
      title: t('remittance.pageSummaryTitle'),
      description: t('remittance.pageSummaryDescription'),
    },
    [REMITTANCE_STEPS.notFound]: {
      title: t('remittance.pageSearchTitle'),
      description: t('remittance.pageSearchDescription'),
    },
  }) as const;

export const REMITTANCE_BENEFICIARY_INITIAL_STATE = {
  full_name: '',
  document: '',
  complement: '',
  country: '',
  documentType: '',
} as const;

export enum REMITTANCE_REPORTS_TABS {
  DAILY,
  MONTHLY,
}

export const REMITTANCE_PLACES: RemittancePlace[] = [
  { id: 'SANTA CRUZ', name: 'SCZ', code: '208' },
  { id: 'LA PAZ', name: 'LPZ', code: '26' },
  { id: 'COCHABAMBA', name: 'CBBA', code: '96' },
  { id: 'BENI', name: 'BNI', code: '287' },
  { id: 'PANDO', name: 'PND', code: '306' },
  { id: 'CHUQUISACA', name: 'CHU', code: '1' },
  { id: 'TARIJA', name: 'TJA', code: '197' },
  { id: 'ORURO', name: 'ORU', code: '146' },
  { id: 'POTOSI', name: 'PO', code: '167' },
];

export const REMITTANCE_MONTHS: string[] = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

export const REMITTANCE_YEARS: string[] = [
  '2025',
  '2024',
  '2023',
  '2022',
  '2021',
  '2020',
  '2019',
  '2018',
  '2017',
  '2016',
  '2015',
  '2014',
  '2013',
  '2012',
  '2011',
  '2010',
  '2009',
  '2008',
  '2007',
  '2006',
];
